import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { resourceFields } from '../../data/Constants';
import { resourceFormStyle } from '../../css/style';
import * as utilFunctions from '../../utils/Functions';

const styles = resourceFormStyle();

class ToolTip extends Component {
  constructor(props) {
    super(props);
  }

  getToolTipText = (items) => {
    const { field, match } = this.props;
    const { resource, subResource } = match.params;
    const subResources = ['options', 'items', 'customizations', 'addresses', 'zones'];
    let toolTip;
    let fieldObject;
    if (subResources.includes(subResource)) {
      fieldObject = resourceFields[subResource].filter(object => object.key === field.key)[0];
    } else if (items !== undefined && items.length > 0) {
      fieldObject = resourceFields.items.filter(object => object.key === field.key)[0];
    } else {
      fieldObject = resourceFields[resource].filter(object => object.key === field.key)[0];
    }
    if (fieldObject !== undefined && fieldObject.toolTip) {
      toolTip = fieldObject.toolTip;
    } else {
      toolTip = '';
    }
    return toolTip;
  };

  render() {
    const { items, width } = this.props;
    return (
      (this.getToolTipText(items) !== undefined && this.getToolTipText(items).length !== 0)
        ? (
          <Tooltip title={this.getToolTipText(items)} placement="right-start">
            <InfoIcon style={utilFunctions.isDeviceView('sm', width) ? styles.infoIconMobile : styles.infoIcon} />
          </Tooltip>
        )
        : (
          <div />
        )
    );
  }
}

ToolTip.propTypes = {
  resources: PropTypes.objectOf(PropTypes.any),
  field: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(ToolTip);
